import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import City from "./City";
import Model from "./Model";
export class CountryState extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'country_states_id',
      content: null
    });
    _defineProperty(this, "CountryStateId", {
      fieldName: 'country_states_id',
      content: null
    });
    _defineProperty(this, "CountryStateCountry", {
      fieldName: 'country_states_country',
      content: null
    });
    _defineProperty(this, "CountryStateName", {
      fieldName: 'country_state_name',
      content: null
    });
    _defineProperty(this, "CountryStateNativeName", {
      fieldName: 'country_state_name_native',
      content: null
    });
    _defineProperty(this, "CountryStateCode", {
      fieldName: 'country_state_code',
      content: null
    });
    _defineProperty(this, "CountryStateType", {
      fieldName: 'country_state_type',
      content: null
    });
    _defineProperty(this, "CountryStateLatitude", {
      fieldName: 'country_state_latitude',
      content: null
    });
    _defineProperty(this, "CountryStateLongitude", {
      fieldName: 'country_state_longitude',
      content: null
    });
    _defineProperty(this, "CountryStateCities", {
      fieldName: 'country_state_cities',
      model: City,
      content: null
    });
  }
  getId() {
    return this.Id.content;
  }
  getNativeName() {
    return this.CountryStateNativeName.content;
  }
  getName() {
    return this.CountryStateName.content;
  }
}
export default CountryState;